import React from "react";
import Slider from "react-slick";



const IndustryList = () => {

  const expsettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    className: "center",
    centerMode: true,
    centerPadding: "50px",
    speed: 500,
    slidesToShow: 7,
    arrows:true,
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />,
    //   prevArrow: <CustomPrevArrow />,
    nextArrow: false,
    prevArrow: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        //   dots: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
        //   dots: true,
        },
      },
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
        //   dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 2,
          centerPadding: "30px",
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "30px",
          
        },
      },
    ],
  };


 const industrylist=[

    {   icon:'https://glocify.com/images/ind1.svg',
        title:'e-Commerce',
        bg:'#f02d2d'   
    },
    {   icon:'https://glocify.com/images/auto.svg',
        title:'Automotive',        
        bg:'#086def'
    },
    {   icon:'https://glocify.com/images/ind4.svg',
        title:'Marketplace', 
        bg:'#00c2ff' ,
        
       
    },
    {   icon:'https://glocify.com/images/crypto.svg',
        title:'Cryptocurrency', 
        bg:'#ffd600'       
       
    },
    {   icon:'https://glocify.com/images/ind1.svg',
        title:'E-Retail',  
        bg:'#952df0'      
         
    },
    {   icon:'https://glocify.com/images/health.svg',
        title:'Health',        
        bg:'#2d43f0'
    },
    {   icon:'https://glocify.com/images/pos.svg',
        title:'Point of Sale (POS)', 
        bg:'#0be1bc'       
        
    },
    {   icon:'https://glocify.com/images/finance.svg',
        title:'Finance',
        bg:'#f09b2d'        
         
    },

    {   icon:'https://glocify.com/images/tech.svg',
        title:'Technology',
        bg:'#ff0097'       
    },
    {   icon:'https://glocify.com/images/telecomm.svg',
        title:'Telecom',  
        bg:'#bdf51b'        
        
    },
    {   icon:'https://glocify.com/images/educ.svg',
        title:'Education',  
        bg:'#F05C2D'      
       
    },
    {   icon:'https://glocify.com/images/entertain.svg',
        title:'Entertainment', 
        bg:'#952df0'        
       
    },
    {   icon:'https://glocify.com/images/realestate.svg',
        title:'Real Estate',  
        bg:'#086def'      
         
    },
    {   icon:'https://glocify.com/images/hospitality.svg',
        title:'Hospitality', 
        bg:'#0be1bc'      
        
    },
    {   icon:'https://glocify.com/images/tour travel.svg',
        title:'Travel & Tourism', 
        bg:'#ff0097'       
        
    },
    {   icon:'https://glocify.com/images/transport.svg',
        title:'Logistics/Transport',   
        bg:'#00b6ff'     
         
    },
    {   icon:'https://glocify.com/images/food.svg',
        title:'Food & Beverage',  
        bg:'#3dff3c' ,      
         
    },
    {   icon:'https://glocify.com/images/pharma.svg',
        title:'Pharmaceuticals',  
        bg:'#f09b2d'      
         
    }
]
  return (
  <>
  
  <style>
        {`
         
.industryslider button.slick-arrow.slick-next {
  display: block !important;
  width: 90px;
  height: 90px;
  background: url('https://glocify.com/images/next.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  right:0px !important;
 
}
.industryslider button.slick-arrow.slick-prev {
  display: block !important;
  width: 90px;
  height: 90px;
  background: url('https://glocify.com/images/prev.svg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
   left:0px !important;
    
}
   .industryslider .slick-arrow{opacity:.6; !important}
   .industryslider  .slick-arrow:hover{opacity:1; !important}
   .industryslider .slick-arrow{z-index:99;}
   .industryslider .slick-arrow:before{opacity:0;}
        `}
      </style>
    <div className="slider-container industryslider  ">
      <Slider {...expsettings}>
        {industrylist.map((item, index) => (
          <div key={index} className="px-3  py-5">
          <div  key={index}   className=" overflow-hidden bg-white rounded-[30px] px-[20px] py-[25px] w-full h-full relative shadow" style={{background: `linear-gradient(45deg, white, ${item.bg+'40'})`}}>
          <span className="absolute w-[100%] h-[100%] left-[30%] fil top-[20%] block graph z-[-1] opacity-[.1] hue-rotate-[167] bightness-[150%]" ><img className="w-full" src={item.icon}/></span>
                    <div className="icon-box min-h-[45px] mx-auto flex justify-center mt-4"><img src={item.icon} alt="Industries "/></div>
                   
                    <h3 className=" text-[20px] md:text-[20px]  lg:text-[22px] font-semibold mt-[20px] min-h-[60px] tracking-tight text-center">{item.title}</h3>
                    {/* <p className="mt-[5px] text-[15px] font-medium text-[#262626]">{item.text}</p> */}
                </div>
          </div>
        ))}
      </Slider>
    </div>   
 </>
  );
};

export default IndustryList;
